<template>
  <div class="home-category" :class="[deviceType]">
    <div class="category-header">
      <div class="category-dot"></div>
      <div class="category-title">Categories</div>
    </div>
    <div class="category-content">
      <div class="category-section" v-for="(section, sectionIndex) in categories"
        :key="sectionIndex">
        <div class="section-header">
          <div class="icon-container">
            <div class="icon-bg"></div>
            <img :src="section.icon" alt="category icon" class="section-icon" />
          </div>
          <div class="section-title">{{ section.title }}</div>
        </div>
        <div class="section-items">
          <router-link v-for="(item, itemIndex) in section.items" :key="itemIndex"
            :to="getCategoryPath(section.title, item.title)" tag="div" class="category-item-link">
            <div class="category-item" :class="{ 'active': item.active }"
              @mouseenter="setHovered(sectionIndex, itemIndex, true)"
              @mouseleave="setHovered(sectionIndex, itemIndex, false)">
              <div class="item-title">{{ item.title }}</div>
              <div class="arrow-icon">
                <img src="@/assets/default/arrow-right-small.svg" alt="arrow right" />
              </div>
            </div>
          </router-link>
        </div>
        <router-link :to="getCategoryPath(section.title)" tag="div" class="view-all-link">
          <div class="view-all">
            <div class="view-all-text">View All</div>
            <div class="arrow-icon">
              <img src="@/assets/default/arrow-right-small.svg" alt="arrow right" />
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'HomeCategory',
  data () {
    return {
    };
  },
  computed: {
    ...mapGetters([
      'deviceType',
      'gender',
      'style',
      'meaning'
    ]),
    categories () {
      const result = [];
      if (this.gender && this.gender.length > 0) {
        result.push({
          title: 'Name by Gender',
          icon: require('@/assets/icons/gender.svg'),
          items: this.gender.slice(0, 3).map(i => ({ title: i }))
        });
      }
      if (this.style && this.style.length > 0) {
        result.push({
          title: 'Name by Style',
          icon: require('@/assets/icons/style.svg'),
          items: this.style.slice(0, 3).map(i => ({ title: i }))
        });
      }
      if (this.meaning && this.meaning.length > 0) {
        result.push({
          title: 'Name by Meaning',
          icon: require('@/assets/icons/meaning.svg'),
          items: this.meaning.slice(0, 3).map(i => ({ title: i }))
        });
      }
      return result;
    }
  },
  methods: {
    setHovered (sectionIndex, itemIndex, isHovered) {
      this.categories[sectionIndex].items[itemIndex].hovered = isHovered;
    },
    getCategoryPath (sectionTitle, itemTitle = null) {
      let categoryType = '';
      switch (sectionTitle) {
        case 'Name by Gender':
          categoryType = 'gender';
          break;
        case 'Name by Style':
          categoryType = 'style';
          break;
        case 'Name by Meaning':
          categoryType = 'meaning';
          break;
        default:
          categoryType = 'general';
      }

      if (itemTitle) {
        const formattedValue = itemTitle.toLowerCase();
        console.log(`/categories/${categoryType}/${formattedValue}`);
        return `/categories/${categoryType}/${formattedValue}`;
      } else {
        return `/categories/${categoryType}`;
      }
    },
    viewAll (sectionIndex) {
      // 处理查看全部的点击事件
      const section = this.categories[sectionIndex];
      let path = '/categories';

      // 根据不同的分类类型，构建不同的路由路径
      switch (section.title) {
        case 'Name by Gender':
          path = '/categories/gender';
          break;
        case 'Name by Style':
          path = '/categories/style';
          break;
        case 'Name by Meaning':
          path = '/categories/meaning';
          break;
        default:
          path = '/categories';
      }

      // 导航到对应的分类页面
      this.$router.push(path);
    },
    navigateToCategory (sectionIndex, itemIndex) {
      const section = this.categories[sectionIndex];
      const item = section.items[itemIndex];
      let categoryType = '';

      // 根据不同的分类类型，构建不同的路由路径
      switch (section.title) {
        case 'Name by Gender':
          categoryType = 'gender';
          break;
        case 'Name by Style':
          categoryType = 'style';
          break;
        case 'Name by Meaning':
          categoryType = 'meaning';
          break;
        default:
          categoryType = 'general';
      }

      // 将分类项的标题转换为URL友好的格式
      const formattedValue = item.title.toLowerCase();

      // 构建路由路径，使用随机ID（实际应用中应该使用真实ID）
      const randomId = Math.floor(Math.random() * 1000) + 1;
      const path = `/categories/${categoryType}/${formattedValue}/${randomId}`;

      // 导航到对应的分类详情页面
      this.$router.push(path);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.home-category {
	padding: rem(60) 0;
	display: flex;
	flex-direction: column;
	gap: rem(24);
	align-items: flex-start;
	justify-content: flex-start;
	position: relative;

	.category-header {
		padding: 0 rem(180);
		display: flex;
		flex-direction: row;
		gap: rem(16);
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		position: relative;

		.category-dot {
			background: #a31984;
			border-radius: rem(100);
			width: rem(8);
			height: rem(4);
			position: relative;
		}

		.category-title {
			color: #03133a;
			text-align: left;
			font-size: rem(28);
			line-height: rem(28);
			font-weight: 900;
			position: relative;
		}
	}

	.category-content {
		padding: 0 rem(180);
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: space-between;
		align-self: stretch;
		position: relative;

		.category-section {
			background: #f7f3f3;
			border-radius: rem(36);
			padding: rem(24);
			display: flex;
			flex-direction: column;
			gap: rem(20);
			align-items: flex-start;
			justify-content: flex-start;
			width: rem(344);
			position: relative;

			.section-header {
				display: flex;
				flex-direction: row;
				gap: rem(16);
				align-items: center;
				justify-content: flex-start;
				align-self: stretch;
				position: relative;

				.icon-container {
					width: rem(36);
					height: rem(36);
					position: relative;
					flex-shrink: 0;

					.icon-bg {
						background: #a31984;
						border-radius: rem(12);
						width: rem(36);
						height: rem(36);
						position: absolute;
						left: 0;
						top: 0;
						aspect-ratio: 1;
					}

					.section-icon {
						width: rem(20);
						height: rem(20);
						position: absolute;
						left: 50%;
						top: 50%;
						transform: translate(-50%, -50%);
					}
				}

				.section-title {
					color: #a31984;
					text-align: left;
					font-size: rem(20);
					line-height: rem(20);
					font-weight: 900;
					position: relative;
				}
			}

			.section-items {
				display: flex;
				flex-direction: column;
				gap: rem(8);
				align-items: flex-end;
				justify-content: flex-start;
				align-self: stretch;
				position: relative;

				.category-item-link {
					text-decoration: none;
					width: 100%;
				}

				.category-item {
					background: #ffffff;
					border-radius: rem(20);
					border: rem(2) solid rgba(163, 25, 132, 0.1);
					padding: rem(18) rem(24);
					display: flex;
					flex-direction: row;
					align-items: center;
					justify-content: space-between;
					align-self: stretch;
					height: rem(60);
					position: relative;
					cursor: pointer;
					transition: all 0.3s ease;

					&:hover,
					&.active {
						background: transparent;
						border-color: #a31984;
						border-width: rem(1);

						.item-title {
							color: #a31984;
						}
					}

					&.active {
						border-color: #a31984;
						border-width: rem(1);
						background: transparent;

						.item-title {
							color: #a31984;
						}
					}

					.item-title {
						color: #03133a;
						text-align: left;
						font-size: rem(18);
						line-height: rem(20);
						font-weight: 700;
						position: relative;
						transition: color 0.3s ease;
					}

					.arrow-icon {
						width: rem(6);
						height: rem(12);
						position: relative;

						img {
							width: 100%;
							height: 100%;
						}
					}
				}
			}

			.view-all-link {
				text-decoration: none;
				width: 100%;
			}

			.view-all {
				border-radius: rem(12);
				border: rem(1) solid transparent;
				padding: rem(8) rem(24);
				display: flex;
				flex-direction: row;
				gap: rem(12);
				align-items: center;
				justify-content: flex-end;
				align-self: stretch;
				position: relative;
				cursor: pointer;

				&:hover {
					opacity: 0.8;
				}

				.view-all-text {
					color: #a31984;
					text-align: center;
					font-size: rem(16);
					line-height: rem(16);
					font-weight: 700;
					position: relative;
				}

				.arrow-icon {
					width: rem(6);
					height: rem(12);
					position: relative;

					img {
						width: 100%;
						height: 100%;
					}
				}
			}
		}
	}
}

.detect_deviece_mobile {
	.home-category {
		padding: rem(60) 0;

		.category-header {
			padding: 0 rem(16);
		}

		.category-content {
			padding: 0 rem(16);
			flex-direction: column;
			gap: rem(16);

			.category-section {
				width: 100%;
			}
		}
	}
}
</style> 